import React from 'react';

import teamBadgePlaceholder from '../assets/images/team_badge_placeholder.svg';
import SPORT_TYPES from '../utils/sportTypes';

const RESULT_COLORS = { W: "#4AED88", D: "#FFD700", L: "#FF7B7B", default: "#7F8585" };
const getResultColor = (r) => RESULT_COLORS[r] || RESULT_COLORS.default;

const renderFormDots = (results) => {
  if (!results || results.length === 0) {
    return <span className="text-app-text-secondary text-xs">-</span>;
  }

  return (
    <div className="flex gap-1 justify-center">
      {results.slice(-5).map((res, i) => (
        <div
          key={i}
          className="w-4 h-4 rounded-full border border-app-bg"
          style={{ backgroundColor: getResultColor(res.toUpperCase()), marginLeft: i > 0 ? -7 : 0 }}
        />
      ))}
    </div>
  );
};

const StandingsTableV2 = ({
  standings = [],
  sportType = SPORT_TYPES.FOOTBALL,
}) => {
  const isFootball = sportType === SPORT_TYPES.FOOTBALL;

  return (
    <div className="bg-app-surface rounded-2xl border border-[#192634] overflow-hidden">
      <div className="overflow-x-auto bg-app-surface">
        <table className="w-full text-left text-sm table-fixed min-w-[900px]">
          <thead>
            <tr className="bg-blue-shade-10 text-[#B2B5AD] border-b border-[#192634]">
              <th className="p-4 font-medium text-center w-12">#</th>
              <th className="p-4 font-medium w-[220px]">Team</th>
              <th className="p-4 font-medium text-center w-16">P</th>
              <th className="p-4 font-medium text-center w-16">W</th>
              <th className="p-4 font-medium text-center w-16">D</th>
              <th className="p-4 font-medium text-center w-16">L</th>
              <th className="p-4 font-medium text-center w-16">
                {isFootball ? 'GF' : 'PF'}
              </th>
              <th className="p-4 font-medium text-center w-16">
                {isFootball ? 'GC' : 'PA'}
              </th>
              <th className="p-4 font-medium text-center w-16">{isFootball ? 'GD' : 'PD'}</th>
              <th className="p-4 font-medium text-center w-20">Points</th>
              <th className="p-4 font-medium text-center w-28">Form</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#192634]">
            {standings.map((team) => (
              <tr
                key={team.teamId}
                className="bg-[#000F1F] hover:bg-app-hover transition-colors"
              >
                <td className="p-4 text-center text-[#FEFCEB] font-medium">
                  {team.rank}
                </td>
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <img
                      src={team.crest || teamBadgePlaceholder}
                      alt={team.title}
                      className="w-6 h-6 rounded-full object-cover bg-gray-800"
                      onError={(e) => {
                        e.target.src = teamBadgePlaceholder;
                      }}
                    />
                    <span className="text-[#FEFCEB] font-medium truncate max-w-[180px]">
                      {team.title}
                    </span>
                  </div>
                </td>
                <td className="p-4 text-center text-app-text-secondary">{team.matchesPlayed}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.wins}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.draws}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.losses}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.goalsScored}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.goalsConceded}</td>
                <td className="p-4 text-center text-app-text-secondary">{team.goalDifference}</td>
                <td className="p-4 text-center text-app-text font-bold">{team.points}</td>
                <td className="p-4">
                  <div className="flex items-center justify-center">
                    {renderFormDots(team.lmResults)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StandingsTableV2;
